// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../../../node_modules/css-loader/index.js??ref--8-1!./iconfont.css");
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = require("!../../../node_modules/vue-style-loader/lib/addStylesClient.js")("7d833824", content, true, {});


//////////////////
// WEBPACK FOOTER
// ./src/assets/iconfont/iconfont.css
// module id = muQq
// module chunks = 215